import { forwardRef } from 'react';
import { StyledFieldInput } from './styled';
import { useFieldContext } from '../../../contexts/field';

const FieldInput = forwardRef((props, ref) => {
  const { inputProps } = useFieldContext();

  return <StyledFieldInput {...inputProps(ref, props)} />;
});

export default FieldInput;
